
// Wrapper function to prevent right mouse clicks for mouse events
// For touch events, prevents calling the handler if the event appears to be a swipe
export default function (next) {
  return function (e) {
    if (/^mouse|click/.test(e.type) && e.which === 1 && !e.ctrlKey) {
      return next.apply(this, arguments)
    }

    if (/^touch/.test(e.type)) {
      return next.apply(this, arguments)
    }
  }
}
